import { render, staticRenderFns } from "./production_orders.vue?vue&type=template&id=4245fec2"
import script from "./production_orders.vue?vue&type=script&lang=js"
export * from "./production_orders.vue?vue&type=script&lang=js"
import style0 from "./production_orders.vue?vue&type=style&index=0&id=4245fec2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports